import type { FaireProductEntity } from "../../entity_types/product";

export const p_xnvpxb8uqn: FaireProductEntity = {
  token: "p_xnvpxb8uqn",
  type: "product",
  name: "Bath Soak - 8 oz. Jar - Spa - Aromatherapy - Natural",
  brandName: "Relax Away Essentials",
  imageUrl:
    "https://cdn.faire.com/fastly/53d1a048f3babd55d03897671e2e839874a9170ac1df2d4c498f19fbb022f6e3.jpeg",
  priceDollars: 8,
  description: "",
  categoryTokens: ["cat_accessories"],
  tags: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:23:30Z",
    importedBy: "retailerThemesSeed-migration",
  },
  freeShipping: true,
  brandAvatarUrl:
    "https://cdn.faire.com/fastly/f70ad36f43f1d15e960cbacab7869dab24a52edaa260f2b60b797599df504f6e.png",
  weight: 0.5,
  dimensions: {
    width: 4,
    height: 4,
    depth: 2,
  },
  inStock: true,
};
